var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8032 3.72903L20.5388 9.83612C20.8301 10.0661 21 10.4166 21 10.7877C21 11.4574 20.4572 12.0002 19.7875 12.0002H19.2V15.1502C19.2 17.6958 19.2 18.9685 18.4092 19.7594C17.6183 20.5502 16.3456 20.5502 13.8 20.5502H10.2C7.65441 20.5502 6.38162 20.5502 5.59081 19.7594C4.8 18.9685 4.8 17.6958 4.8 15.1502V12.0002H4.21244C3.54284 12.0002 3 11.4574 3 10.7877C3 10.4166 3.16992 10.0661 3.46116 9.83612L11.1968 3.72903C11.4255 3.54843 11.7085 3.4502 12 3.4502C12.2915 3.4502 12.5745 3.54843 12.8032 3.72903Z",
    stroke: "#3E7C50",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 20.55V16.5C14.25 15.6589 14.25 15.2383 14.0691 14.925C13.9507 14.7198 13.7802 14.5493 13.575 14.4309C13.2617 14.25 12.8411 14.25 12 14.25C11.1589 14.25 10.7383 14.25 10.425 14.4309C10.2198 14.5493 10.0493 14.7198 9.93086 14.925C9.75 15.2383 9.75 15.6589 9.75 16.5V20.55",
    stroke: "#3E7C50",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.7c802332be5a0d12d1d0ab549090cf40.svg";
export { ForwardRef as ReactComponent };